import styled from 'styled-components';

import { LogoSvg } from '../../assets/icons';
import theme from '../../assets/theme';

export const SlideLogo = ({
  onClick,
  color,
  cursor,
  height,
  width,
}: {
  onClick?: () => void;
  color?: string;
  cursor?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <ShortLogoContainer
      onClick={onClick}
      $color={color ? color : 'white'}
      $cursor={cursor}
      $height={height}
      $width={width}
    >
      <LogoSvg />
    </ShortLogoContainer>
  );
};

const ShortLogoContainer = styled.div<{
  $color?: string;
  $cursor?: string;
  $height?: string | null;
  $width?: string | null;
}>`
  cursor: ${({ $cursor }) => ($cursor ? $cursor : 'pointer')};
  color: ${({ $color }) => ($color ? $color : theme.colors.white)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => ($width ? $width : '0px')};
  height: ${({ $height }) => ($height ? $height : '0px')};
  @media (max-width: 992px) {
    svg {
      width: ${({ $width }) => ($width ? $width : '0px')};
      height: ${({ $height }) => ($height ? $height : '0px')};
    }
  }
  @media (max-width: 800px) {
    svg {
      width: ${({ $width }) => ($width ? $width : '0px')};
      height: ${({ $height }) => ($height ? $height : '0px')};
    }
  }
`;
